import {
  ReferenceLayoutSkeleton,
  SuspensePageBoundary,
} from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { View, Text } from "@-/com.npmjs.react-native";
import { type ReactNode } from "react";

/**
 * One titled block of the Reference page.
 *
 * Each section keeps its own suspense boundary because the panel sub-screens it wraps self-fetch
 * their own slice. A shared boundary would let the slowest section (typically Sentences) hold the
 * whole scroll blank, which is precisely what the two-panel layout avoided by mounting one panel at
 * a time — the single-scroll page has to buy that back per section.
 */
export function GraphemeReferenceSection({
  children,
  title,
}: {
  children: ReactNode;
  title: string;
}) {
  return (
    <View className="border-b border-border px-4 py-6">
      <Text
        accessibilityRole="header"
        className="mb-3 text-xs font-semibold tracking-wide text-muted-foreground uppercase"
      >
        {title}
      </Text>
      <SuspensePageBoundary fallback={<ReferenceLayoutSkeleton />} location={import.meta.location}>
        {children}
      </SuspensePageBoundary>
    </View>
  );
}
